module.exports = __webpack_public_path__ + "img/icmcup-icmtrader.7bb7d462.svg";